import { defineStore } from 'pinia'
import { $themeConfig } from '@themeConfig'

export const useVerticalMenuStore = defineStore('VerticalMenuStore', {
  state: () => ({
    isVerticalMenuCollapsed: $themeConfig.layout.menu.isCollapsed,
  }),
  actions: {
    updateVerticalMenuCollapsed(val) {
      this.isVerticalMenuCollapsed = val
    },
  },
})
